/**
 * @generated SignedSource<<369ae32601f07d53f6c27c0a66cfe186>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useIsPrimarySale_nftItem$data = {
  readonly contract: {
    readonly addressWithFields: {
      readonly owner: {
        readonly address: string | null;
      } | null;
    } | null;
  } | null;
  readonly creatorAddress: {
    readonly address: string | null;
  } | null;
  readonly lastLiveAuction: {
    readonly sellerAddress: {
      readonly address: string | null;
    } | null;
  } | null;
  readonly ownerAddress: {
    readonly address: string | null;
  } | null;
  readonly " $fragmentType": "useIsPrimarySale_nftItem";
};
export type useIsPrimarySale_nftItem$key = {
  readonly " $data"?: useIsPrimarySale_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsPrimarySale_nftItem">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "address",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useIsPrimarySale_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NftTokenContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "addressWithFields",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EthereumAddressType",
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "creatorAddress",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "ownerAddress",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": "lastLiveAuction",
      "args": [
        {
          "kind": "Literal",
          "name": "excludeCanceled",
          "value": true
        }
      ],
      "concreteType": "NftAuction",
      "kind": "LinkedField",
      "name": "mostRecentAuction",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "sellerAddress",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "mostRecentAuction(excludeCanceled:true)"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};
})();

(node as any).hash = "9813008c77e22522a8f2608c1940e312";

export default node;
